import { Progress } from '@heroui/react';
import { FaStar, FaRegStar } from 'react-icons/fa6';

interface RatingDistributionProps {
  rating: {
    totalReviews: number;
    averageRating: number;
    ratingBreakdown: {
      [key: string]: { count: number; percentage: number };
    };
  };
}

const RatingDistribution = ({ rating }: RatingDistributionProps) => {
  const breakdown = rating?.ratingBreakdown || {};

  // Convert breakdown into sorted array (5 → 1)
  const ratings = Object.entries(breakdown)
    .map(([stars, data]) => ({
      stars: Number(stars),
      value: data.percentage,
      count: data.count,
    }))
    .sort((a, b) => b.stars - a.stars);

  return (
    <div className="space-y-2 -mt-3">
      {ratings.map((r) => (
        <div key={r.stars} className="flex items-center gap-2 w-full">
          {/* Stars */}
          <div className="flex gap-1 w-[70px] justify-start">
            {Array.from({ length: 5 }).map((_, i) =>
              i < r.stars ? (
                <FaStar key={i} className="text-xs fill-secondary" />
              ) : (
                <FaRegStar key={i} className="text-xs text-gray-300" />
              )
            )}
          </div>

          {/* Progress bar */}
          <div className="flex-1">
            <Progress
              aria-label={`${r.stars} star rating`}
              size="sm"
              value={r.value}
            />
          </div>

          {/* Count */}
          <div className="w-[50px] text-right">
            <p className="text-xs">({r.count})</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default RatingDistribution;
